var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.$util.formatDur2(_vm.startTime)))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$util.formatDur2(_vm.startTime+_vm.cutDuration)))]),_vm._v(" "),_c('span',[_vm._v("/")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$util.formatDur2(_vm.duration)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e09bda2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popups/content/videoSpriteDuration.vue
// module id = null
// module chunks = 